var windowWidth, lazyLink, lazyImages, lazyBackground, lazyIframe, lazyScripts, navigator_platform, lazyLoadedJS, s, i, j, flag;
function init(){
  1 == flag && ((flag = 0), lazyLoadImg(), lazyLoadBackground(), lazyLoadIframe(), load_all_js());
}
function isElementInViewport(t){
  "function" == typeof jQuery && t instanceof jQuery && (t = t[0]);
  var e = t.getBoundingClientRect();
  return e.top >= 0 && e.left >= 0 && e.bottom <= (window.innerHeight || document.documentElement.clientHeight) && e.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function lazyLoadLink(){
  lazyLink.forEach(function (t){
    t.href = null == t.dataset.href ? t.href : t.dataset.href;
  });
}
function lazyLoadImg(){
  lazyImages.forEach(function (t){
    (t.src = windowWidth < 600 ? (null == t.dataset.mobsrc ? t.dataset.src : t.dataset.mobsrc) : t.dataset.src), t.classList.remove("lazy2");
  });
}
function lazyLoadBackground(){
  lazyBackground.forEach(function (t){
    (t.style = windowWidth < 600 ? (null == t.dataset.mobstyle ? t.dataset.style : t.dataset.mobstyle) : t.dataset.style), t.classList.remove("lazybg");
  });
}
function lazyLoadIframe(){
  lazyIframe.forEach(function (t){
    t.src = null == t.dataset.src ? t.src : t.dataset.src;
  });
}
function lazyLoadScripts(){
  document.querySelectorAll("link[data-href]").forEach(link => {
    const css = link.dataset.href;
    lazyLoadCss(css);
  });
  j != lazyScripts.length &&
      ("noscript-s" == lazyScripts[j].getAttribute("type")
          ? (lazyScripts[j].setAttribute("type", "lazyloaded"),
            void 0 !== lazyScripts[j].dataset.src
                ? (((s = document.createElement("script")).src = lazyScripts[j].dataset.src),
                  document.body.appendChild(s),
                  (s.onload = function () {
                      j++, lazyLoadScripts();
                  }))
                : (((s = document.createElement("script")).innerHTML = lazyScripts[j].innerHTML), document.body.appendChild(s), j++, lazyLoadScripts()))
          : (j++, lazyLoadScripts()));
}
function lazyLoadCss(t){
  ((s = document.createElement("link")).rel = "stylesheet"), (s.href = t), document.getElementsByTagName("head")[0].appendChild(s);
}
function lazyLoadCss2(t, e){
  var a = new XMLHttpRequest();
  (a.onreadystatechange = function (){
    4 == this.readyState && 200 == this.status && (document.getElementById(e).innerHTML = this.responseText);
  }),
    a.open("GET", t, !0),
    a.send();
}
function lazyLoadJS(t){
    lazyLoadedJS &&
        (setTimeout(function () {
            lazyLoadJS(t);
        }, 200),
        (lazyLoadedJS = 0)),
        (lazyLoadedJS = 1),
        ((s = document.createElement("script")).src = t),
        (s.onload = function () {
            lazyLoadedJS = 0;
        }),
        document.body.appendChild(s);
}
function load_all_js(){
        window.location.href.indexOf("secodev1.myshopify.com") > -1 || window.location.href.indexOf("/cart") > -1 || window.location.href.indexOf("/checkout") > -1
            ? console.log("No-optimization")
            : (console.log("Yes-optimization"),
              setTimeout(function () {
                  var t = new Event("wnw_load");
                  window.dispatchEvent(t);
              }, 200)),

        (j = 0),
        (lazyScripts = document.getElementsByTagName("script")),
        lazyLoadScripts(),
        setTimeout(function (){
            var t = new Event("DOMContentLoaded2", { bubbles: !0, cancelable: !0 });
            window.dispatchEvent(t);
        }, 5e3),
        setInterval(function (){
            (lazyImages = document.querySelectorAll("img.lazy2")), (lazyBackground = document.querySelectorAll(".lazybg")), lazyLoadImg(), lazyLoadBackground();
        }, 3e3);
}
function initHandler(){
  (windowWidth = screen.width),
      (lazyLink = document.querySelectorAll("link")),
      (lazyImages = document.querySelectorAll("img.lazy2")),
      (lazyBackground = document.querySelectorAll(".lazybg")),
      (lazyIframe = document.querySelectorAll("iframe")),
      (lazyScripts = document.getElementsByTagName("script")),
      (i = 0),
      (j = 0),
      (flag = 1),
      window.addEventListener("scroll", function () {
          init();
      }),
      window.addEventListener("mousemove", function () {
          init();
      }),
      window.addEventListener("touchstart", function () {
          init();
      }),
      setTimeout(function () {
          init();
      }, 9900);
}
if (document.readyState !== 'loading'){
  initHandler();
} else {
  document.addEventListener('DOMContentLoaded', initHandler);
}
